/** How much of the monthly order limit is used, see `useMonthlyOrderUsage` for the thresholds */
export enum UsageStatus {
    /** Under 50% */
    ON_TRACK = 'ON_TRACK',
    /** 50% up to 75% */
    RUNNING_LOW = 'RUNNING_LOW',
    /** 75% up to 100% */
    ALMOST_FULL = 'ALMOST_FULL',
    /** 100% or more */
    LIMIT_REACHED = 'LIMIT_REACHED',
}
